import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.module'
import data from './data.module'
import auth_user from './authStudent.module'

Vue.use(Vuex)

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    asideShow: false,
    darkMode: false,
    toasts : [],
    userSelect: []
}

const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
    toggle(state, variable) {
        state[variable] = !state[variable]
    },
    addToaster(state, data) {
        let toast = {
            autohide: data.time == null || data.time == undefined || data.time == "" ? 1500 : data.time,
            closeButton: true,
            fade: true,
            position: 'top-right',
            header: data.head,
            body: data.message,
            type: typeToaster(data.type)
        }

        state.toasts.push(toast);
    },
    setUserSelect(state,data){
        let userData = data;
        state.userSelect.push(userData);
    }
}

function typeToaster(type){
    switch(type) {
        case 'Error' :
            return '#e55353';            
        case 'Info' :
            return '#39f';
        case 'Success' :
            return '#2eb85c';        
        case 'Warning' :
            return  '#f9b115';
    }
}

export default new Vuex.Store({
    state,
    mutations,
    modules: {
        auth,
        data,
        auth_user
    }
})
